<script lang="ts">
	import HDPlayerCard from '#lib/hockeydata/components/HDPlayerCard.svelte';
	import { positions } from '#lib/hockeydata/hockeydata.js';
	import type { Position } from '#lib/hockeydata/types/responses/TeamDetails.js';
	import _ from 'lodash';

	const { data } = $props();

	const mostGoals = $derived.by(() => {
		return _.maxBy(data.players, (p) => p.goals);
	});

	const mostPIM = $derived.by(() => {
		return _.maxBy(data.players, (p) => p.penaltyMinutes);
	});
</script>

{#each Object.entries(data.playersByPosition) as position}
	<div class="border-accent border-b-2 text-xl font-bold uppercase">
		{positions[position[0] as Position]}
	</div>
	<div class="grid grid-cols-1 justify-items-center gap-3 md:grid-cols-5">
		{#each position[1] as player}
			<HDPlayerCard {player} showStats>
				{#snippet badges()}
					{#if mostGoals?.id === player.id}
						<span class="mx-2 px-2 py-1 text-sm">Most Goals</span>
					{/if}
					{#if mostPIM?.id === player.id}
						<span class="mx-2 px-2 py-1 text-sm">Most PIM</span>
					{/if}
				{/snippet}
			</HDPlayerCard>
		{/each}
	</div>
{/each}
